import { render, staticRenderFns } from "./ResourceAccess.vue?vue&type=template&id=6b5d3475&scoped=true"
import script from "./ResourceAccess.vue?vue&type=script&lang=js"
export * from "./ResourceAccess.vue?vue&type=script&lang=js"
import style0 from "./ResourceAccess.vue?vue&type=style&index=0&id=6b5d3475&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b5d3475",
  null
  
)

export default component.exports